import { StoreAction, XmAction } from 'store/actions';
import { VideoResolutionInfo } from './models';

export function videoResolutionReducer(state: VideoResolutionInfo[] = [], action: XmAction<VideoResolutionInfo>): VideoResolutionInfo[] {
    let newState: VideoResolutionInfo[];
    switch (action.type) {
        case StoreAction.GET_VIDEO_RESOLUTION:
            newState = state.filter((item: VideoResolutionInfo) => item.lineId !== action.payload.lineId);

            return [ ...newState, action.payload ];
        default:
            return state;
    }
}
